import { render, staticRenderFns } from "./EndpointsList.vue?vue&type=template&id=2a960e62&scoped=true"
import script from "./EndpointsList.vue?vue&type=script&lang=js"
export * from "./EndpointsList.vue?vue&type=script&lang=js"
import style0 from "./EndpointsList.vue?vue&type=style&index=0&id=2a960e62&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a960e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a960e62')) {
      api.createRecord('2a960e62', component.options)
    } else {
      api.reload('2a960e62', component.options)
    }
    module.hot.accept("./EndpointsList.vue?vue&type=template&id=2a960e62&scoped=true", function () {
      api.rerender('2a960e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Endpoints/EndpointsList.vue"
export default component.exports